<!-- 科技成果 -->
<template>
  <div class="development">
    <div class="main">
      <div class="content">
        <div class="main_box">
          <div class="table">
            <table>
              <thead>
                <tr>
                  <th style="width: 25%">项目名称</th>
                  <th>产业领域</th>
                  <th>供应方</th>
                  <th>发布时间</th>
                  <th>审核状态</th>
                  <th style="width: 7%">操作</th>
                </tr>
              </thead>
              <!-- <tbody>
                <tr v-for="item in 16" :key="item">
                  <td style="width: 25%">一种室内空间释放负氧离子移动机器人</td>
                  <td>实用新型</td>
                  <td>2021216676147</td>
                  <td>2026-12-31 15:31:22</td>
                  <td>审核通过</td>
                  <td class="edit" style="width: 7%">编辑</td>
                </tr>
              </tbody> -->
              <tbody>
                <tr v-for="item in tableData" :key="item.id">
                  <td style="width: 25%">{{ item.name }}</td>
                  <td>{{ item.industry_sector }}</td>
                  <td>{{ item.user?.company || "-" }}</td>
                  <td>{{ item.create_time }}</td>
                  <td>
                    <span :class="['status', getStatusClass(item.status)]">
                      {{ getStatusText(item.status) }}
                    </span>
                  </td>
                  <td class="edit" style="width: 7%" @click="handleEdit(item)">
                    编辑
                  </td>
                </tr>
                <!-- <tr v-if="tableData.length === 0">
                  <td colspan="6" style="text-align: center">暂无数据</td>
                </tr> -->
              </tbody>
            </table>
          </div>
          <div class="paging">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMyAchievement } from "../../api/userApi";
export default {
  data() {
    return {
      tableData: [], // 表格数据
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示条数
      total: 0, // 总数据量
      statusOptions: [
        { value: "", label: "全部状态" },
        { value: "0", label: "待审核" },
        { value: "1", label: "已通过" },
        { value: "2", label: "已驳回" },
      ],
      filterStatus: "", // 筛选状态
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    // 获取表格数据
    async fetchData() {
      try {
        const params = {
          page: this.currentPage,
          limit: this.pageSize,
          status: this.filterStatus,
        };

        const response = await getMyAchievement(params);

        if (response.code === 1) {
          this.tableData = response.data || [];
          this.total = response.count || 0;
        } else {
          this.$message.error(response.message || "获取数据失败");
        }
      } catch (error) {
        console.error("获取数据出错:", error);
        this.$message.error("获取数据出错");
      }
    },

    // 状态文本转换
    getStatusText(status) {
      const statusMap = {
        0: "待审核",
        1: "已通过",
        2: "已驳回",
      };
      return statusMap[status] || "-";
    },

    // 状态样式
    getStatusClass(status) {
      const classMap = {
        0: "pending",
        1: "approved",
        2: "rejected",
      };
      return classMap[status] || "";
    },

    // 编辑操作
    handleEdit(item) {
      // 这里可以跳转到编辑页面，传递item.id
      console.log("编辑项目:", item.id);
      this.$router.push({
        path: "/memberCenter/publish-achievement",
        query: { id: item.id },
      });
    },

    // 每页条数变化
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },

    // 页码变化
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
  },
};
</script>

<style scoped lang="less">
.content {
  width: 100%;
  max-width: 87.5rem;
  margin: 0 auto;
  //   position: absolute;
}
.main {
  background: #f5f5f5;
  width: 100%;
  .main_box {
    width: 100%;
    // height: 1017px;
    background: #fff;
    border-radius: 10px;
    // padding: 15px 40px 35px 40px;
    .table {
      //   width: 100%;
      table {
        width: 100%;
        border-collapse: collapse; /* 合并单元格边框 */
        border-spacing: 0; /* 移除单元格之间的间距 */
        margin: 15px 0 35px 0;
        th,
        td {
          /* 强制不换行 */
          white-space: nowrap;
          /* 内容超出容器隐藏 */
          overflow: hidden;
          /* 使用省略号表示被隐藏的内容 */
          text-overflow: ellipsis;
          /* 设置最大宽度或固定宽度 */
          width: 16%; /* 根据实际情况调整 */
          /* 确保内容不会自动扩展td的宽度 */
          display: inline-block;
          /* 可选：设定一个固定高度，如果适用 */
          height: 50px; /* 根据实际情况调整 */
          line-height: 50px;
        }
        thead {
          border-radius: 5px;
          background: #175dc2;

          tr {
            height: 50px;
            th {
              // width: 10%;
              font-family: PingFang SC, PingFang SC;

              font-weight: 600;
              font-size: 14px;
              color: #ffffff;
            }
          }
        }
        tbody {
          tr:nth-child(odd) {
          }
          tr:nth-child(even) {
            background: #f2f4fe;
            border-radius: 5px;
          }
          tr {
            td {
              // height: 50px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #121212;
              // white-space: nowrap; /* 禁止文字换行 */
              // overflow: hidden; /* 超出部分隐藏 */
              // text-overflow: ellipsis;
            }
          }
          .edit {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #175dc2;
            cursor: pointer;
          }
        }
      }
    }
    .paging {
      display: flex;
      justify-content: flex-end;
      padding-right: 45px;
      margin-bottom: 18px;
    }
  }
}
</style>
